import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { WidgetApp } from "./WidgetApp";
import "./widget.css";

/**
 * Entry point for the iframe-hosted widget app.
 *
 * The host page never mounts this directly — the vanilla
 * ``griswold-widget.js`` loader creates an iframe whose ``src`` is
 * ``.../embed/v1/widget.html``, and that HTML loads this module.
 *
 * The widget app reads ``?chatbot=...&tenant=...&origin=...`` from
 * its own URL, then drives the A2UI surface via the shared
 * ``useAGUIChat`` hook + ``<A2UIView>`` (same code path as the admin
 * playground).
 */

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <StrictMode>
      <WidgetApp />
    </StrictMode>,
  );
}
